import React, { FunctionComponent } from "react";
import { Plan } from "../../@types";
import { getBenefitCost, useTranslate } from "../../helpers";

const BenefitsCosts: FunctionComponent<{
  plans: Plan[];
  selectedPlan: Plan | undefined;
}> = ({ plans, selectedPlan }) => {
  const t = useTranslate();

  const benefits = [
    {
      label: t("plan_terms.primary_doctor_visit"),
      benefit: "doctor_visits",
      service: "primary",
    },
    {
      label: t("plan_terms.specialist_visit"),
      benefit: "doctor_visits",
      service: "specialist",
    },
    {
      label: t("plan_terms.diagnostic_tests_and_procedures"),
      benefit: "diagnostic_procedures",
      service: "diagnostic_tests",
    },
    {
      label: t("plan_terms.lab_services"),
      benefit: "diagnostic_procedures",
      service: "lab_services",
    },
    {
      label: t("plan_terms.diagnostic_radiology_services"),
      benefit: "diagnostic_procedures",
      service: "diagnostic_radiology_services",
    },
    {
      label: t("plan_terms.outpatient_xrays"),
      benefit: "diagnostic_procedures",
      service: "outpatient_xrays",
    },
    {
      label: t("plan_terms.emergency_care"),
      benefit: "emergency_care",
      service: "emergency",
    },
    {
      label: t("plan_terms.urgent_care"),
      benefit: "emergency_care",
      service: "urgent_care",
    },
    {
      label: t("plan_terms.inpatient_hospital_coverage"),
      benefit: "inpatient_hospital",
    },
    {
      label: t("plan_terms.outpatient_hospital_coverage"),
      benefit: "outpatient_hospital",
    },
    {
      label: t("plan_terms.preventive_services"),
      benefit: "preventive_care",
    },
  ];

  return (
    <>
      <tr>
        <td
          className="PlanComparePage__tableHeader"
          colSpan={selectedPlan ? 1 : plans.length + 1}
        >
          {t("plan_terms.benefits_and_costs")}
        </td>
      </tr>
      {benefits.map((b, index) => {
        const { label, service, benefit } = b;
        const lastRow = index === benefits.length - 1;

        return (
          <tr key={index}>
            <td
              className={`PlanComparePage__tableLabelColumn ${
                lastRow ? "PlanComparePage__lastRowCell" : ""
              }`}
            >
              {label}
            </td>

            {plans.map((plan, index) => (
              <td
                key={index}
                className={`${
                  selectedPlan?.id === plan.id
                    ? "PlanComparePage__selectedCell"
                    : ""
                } ${lastRow ? "PlanComparePage__lastRowCell" : ""}`}
              >
                <span className="ds-text-heading--md ds-u-display--block ds-u-lg-display--none mct-hide-print">
                  {label}
                </span>
                {getBenefitCost(t, { plan, service, benefit })}
              </td>
            ))}
          </tr>
        );
      })}
    </>
  );
};

export default BenefitsCosts;
